<template>
  <section class="order-wrapper">
    <div
      v-if="showStepButtons"
      class="container"
    >
      <div class="row justify-content-center">
        <div class="col-8">
          <div class="mb-3 justify-content-center">
            <button @click="changeStep(1)">
              1
            </button>
            <button @click="changeStep(2)">
              2
            </button>
            <button @click="changeStep(3)">
              3
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container c-student-vault">
      <div class="row justify-content-center">
        <div class="col-lg-10 border rounded-3 py-3 c-student-vault__container p-4">
          <div class="mb-3 c-student-vault__step-navigation">
            Step
            <span v-text="step"/>
            of
            <span v-text="maxSteps"/>
          </div>

          <div ref="chunk">
            <div class="c-college-storage__inner-section bg-white">
              <div v-show="step === 1">
                <CollegeStorage_AboutYou
                  @back-button-clicked="backStep()"
                  @next-button-clicked="nextStep()"
                />
              </div>

              <div v-show="step === 2">
                <CollegeStorage_StorageOptions
                  @back-button-clicked="backStep()"
                  @next-button-clicked="nextStep()"
                />
              </div>

              <div v-show="step === 3">
                <CollegeStorage_Summary
                  @back-button-clicked="backStep()"
                  @next-button-clicked="nextStep()"
                />
              </div>
            </div>
          </div>

          <div class="mt-4">
            <div class="property-footer">
              <p class="paragraph-small">
                <span class="me-1">
                  Need help?
                  <a :href="`tel:${$siteContext.config.primaryContactPhone.value}`">
                    {{ $siteContext.config.primaryContactPhone.text }}
                  </a>
                </span>
                or
                <span class="ms-1">
                  <a :href="`tel:${$siteContext.config.secondaryContactPhone.value}`">
                    {{ $siteContext.config.secondaryContactPhone.text }}
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import CollegeStorage_AboutYou from "./CollegeStorage_AboutYou.vue";
import CollegeStorage_StorageOptions from "./CollegeStorage_StorageOptions.vue";
import CollegeStorage_Summary from "./CollegeStorage_Summary.vue";
import Vue from "vue";
import {Component} from "vue-property-decorator";

@Component({
  components: {
    CollegeStorage_AboutYou,
    CollegeStorage_StorageOptions,
    CollegeStorage_Summary,
  }
})
export default class CollegeStorageView extends Vue {
  step = 1;
  maxSteps = 3;
  showStepButtons = false;

  mounted() {
    this.$store.dispatch('collegeStorage/loadUserPaymentCards');

    if (this.$store.state.collegeStorage.debugMode)
      this.$store.commit('collegeStorage/loadSandbox');

    this.$store.dispatch('collegeStorage/loadPageData')
      .then(() => {
        if (this.$store.state.collegeStorage.isUserInfoFormPrefilled)
          this.step = 2;
      });
  }

  changeStep(value) {
    this.step = value;
  }

  backStep() {
    if (this.step > 0) {
      this.changeStep(this.step - 1);
      this.scrollToTop();
    }
  }

  nextStep() {
    this.changeStep(this.step + 1);
    this.scrollToTop();
  }


  scrollToTop() {
    document.body.scrollIntoView();
  }
}
</script>
